module.exports = __webpack_public_path__ + "static/media/large.43204b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main-content/weibo-module/Att-404-pic/large.jpg
// module id = 35
// module chunks = 0